<template>
  <div class="com-lang-nav">
    <div v-clickout="close" class="com-lang" :class="[className, type]" @click="toggle">
      <svg class="com-lang-global" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10 19.6667C15.3388 19.6667 19.6667 15.3388 19.6667 10H18.3333C18.3333 14.6024 14.6024 18.3333 10 18.3333V19.6667ZM19.6667 10C19.6667 4.66125 15.3388 0.333333 10 0.333333V1.66667C14.6024 1.66667 18.3333 5.39762 18.3333 10H19.6667ZM10 0.333333C4.66125 0.333333 0.333333 4.66125 0.333333 10H1.66667C1.66667 5.39762 5.39762 1.66667 10 1.66667V0.333333ZM0.333333 10C0.333333 15.3388 4.66125 19.6667 10 19.6667V18.3333C5.39762 18.3333 1.66667 14.6024 1.66667 10H0.333333ZM1 10.6667H19V9.33333H1V10.6667ZM10 19.6667C10.7394 19.6667 11.3764 19.2893 11.8857 18.7508C12.3936 18.2137 12.8202 17.4724 13.1646 16.6116C13.8547 14.8862 14.2667 12.5484 14.2667 10H12.9333C12.9333 12.4222 12.5394 14.5844 11.9266 16.1164C11.6195 16.8842 11.2704 17.4609 10.9169 17.8347C10.5648 18.207 10.2547 18.3333 10 18.3333V19.6667ZM14.2667 10C14.2667 7.45162 13.8547 5.11379 13.1646 3.38844C12.8202 2.52762 12.3936 1.78626 11.8857 1.24919C11.3764 0.71072 10.7394 0.333333 10 0.333333V1.66667C10.2547 1.66667 10.5648 1.79296 10.9169 2.16534C11.2704 2.53912 11.6195 3.11578 11.9266 3.88363C12.5394 5.41564 12.9333 7.57782 12.9333 10H14.2667ZM10 0.333333C9.26056 0.333333 8.62358 0.71072 8.11434 1.24919C7.60644 1.78626 7.17976 2.52762 6.83543 3.38844C6.14529 5.11379 5.73333 7.45162 5.73333 10H7.06667C7.06667 7.57782 7.46059 5.41564 8.0734 3.88363C8.38054 3.11578 8.72959 2.53912 9.08308 2.16534C9.43524 1.79296 9.74532 1.66667 10 1.66667V0.333333ZM5.73333 10C5.73333 12.5484 6.14529 14.8862 6.83543 16.6116C7.17976 17.4724 7.60644 18.2137 8.11434 18.7508C8.62358 19.2893 9.26056 19.6667 10 19.6667V18.3333C9.74532 18.3333 9.43524 18.207 9.08308 17.8347C8.72959 17.4609 8.38054 16.8842 8.0734 16.1164C7.46059 14.5844 7.06667 12.4222 7.06667 10H5.73333ZM3.16465 4.23535C4.91325 5.98394 7.33083 7.06667 10 7.06667V5.73333C7.69865 5.73333 5.61623 4.80131 4.10746 3.29254L3.16465 4.23535ZM10 7.06667C12.6692 7.06667 15.0868 5.98395 16.8354 4.23535L15.8926 3.29254C14.3838 4.80131 12.3014 5.73333 10 5.73333V7.06667ZM16.8354 15.7646C15.0868 14.0161 12.6692 12.9333 10 12.9333V14.2667C12.3014 14.2667 14.3838 15.1987 15.8926 16.7075L16.8354 15.7646ZM10 12.9333C7.33083 12.9333 4.91325 14.0161 3.16465 15.7647L4.10746 16.7075C5.61623 15.1987 7.69865 14.2667 10 14.2667V12.9333Z"
        />
      </svg>
      <template v-if="type === 'text'">
        <span class="com-lang-text">{{ langName }}</span>
        <svg :class="['com-lang-arrow', { active: open }]" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
          <g>
            <g>
              <path id="Vector" d="M4.90039 10.5L9.56706 6.3L4.90039 2.1" />
            </g>
          </g>
        </svg>
      </template>
    </div>
    <transition name="tran-fadeIn">
      <ul v-show="open" :class="['com-lang-list', mask && 'mask', direction]" @click.stop="toggle">
        <li v-for="item in list" :key="item.id" class="com-lang-item">
          <a
            :class="[
              'com-lang-item-link',
              { active: $route.params.lang === (global ? item.lang : `${item.region}_${item.lang}`) }
            ]"
            :href="formatLink(item)"
          >
            {{ item.abbr }}
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'

interface LangConfig {
  id: number
  region: string
  lang: string
  abbr: string
  is_default: boolean
}
const props = defineProps({
  open: {
    type: Boolean,
    default: false
  },
  type: {
    type: String as PropType<'normal' | 'text'>,
    default: 'normal'
  },
  direction: {
    type: String as PropType<'top' | 'bottom'>,
    default: 'bottom'
  },
  list: {
    type: Array as PropType<LangConfig[]>,
    default: () => []
  },
  global: Boolean,
  className: null as unknown as PropType<unknown>,
  mask: Boolean
})
const emit = defineEmits(['update:open'])
const route = useRoute()
const langName = computed(() => {
  const lang = (props.list as LangConfig[]).find((item) => {
    if (props.global) {
      return item.lang === route.params.lang
    } else {
      return `${item.region}_${item.lang}` === route.params.lang
    }
  })
  return lang ? lang.abbr : ''
})
function formatLink(langInfo: LangConfig) {
  if (!props.global) {
    return `/${langInfo.region}_${langInfo.lang}/`
  } else {
    return `/${langInfo.lang}/`
  }
}
function toggle() {
  emit('update:open', !props.open)
}
function close() {
  emit('update:open', false)
}
</script>
<style lang="scss" scoped>
.com-lang-arrow {
  fill: #ffffff;
  transform: rotate(90deg);
  transition: 0.3s;
  width: 20px;
  height: 20px;
  &.active {
    transform: rotate(-90deg);
  }
}
.com-lang-global {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  fill: #fff;
  transition: fill 0.3s;
}
.com-lang-nav {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  &.show {
    .com-lang {
      .com-lang-global {
        fill: white;
      }
    }
  }
}
.com-lang-text {
  margin: 0 8px;
  font-size: 16px;
  color: #fff;
}
.com-lang {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  &.normal {
    justify-content: center;
    width: 64px;
    height: 44px;
    border-radius: 22px;
    background-color: #4ed99b;
    transition: background-color 0.3s;
  }
}
.com-lang-list {
  position: absolute;
  min-width: 120px;
  max-height: calc(36px * 7);
  overflow-x: hidden;
  overflow-y: auto;
  color: #d8d8d8;
  text-align: center;
  background-color: #363a40;
  &.bottom {
    top: calc(100% + 2px);
    right: 0;
    //left: 50%;
    //transform: translate(-50%, 0);
  }
  &.top {
    bottom: 140%;
    left: 50%;
    transform: translate(-50%, 0);
    .com-lang-global {
      width: 20px;
      height: 20px;
    }
  }
  &::-webkit-scrollbar {
    width: 2px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: #666;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
}
.com-lang-item {
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #b8bfc0;
  background-color: #07281f;
}
.com-lang-item-link {
  display: block;
  width: 100%;
  height: 100%;
  white-space: nowrap;
  transition: background-color, color 0.3s;
  &.active {
    color: #fff;
    font-weight: 700;
    background-color: #4ed99b;
  }
}

@media not all and (hover: none) {
  .com-lang-item-link:hover {
    color: #fff;
    &.active {
      color: #fff;
    }
  }
}
@media not all and (min-width: 1024px) {
  .com-lang-list {
    z-index: 1;
    right: 0;
    min-width: 240px;
    max-height: calc(72px * 5);
    &.mask {
      &:after {
        content: '';
        position: fixed;
        z-index: -1;
        width: 100%;
        height: calc(100vh - 120px);
        top: 120px;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
      }
    }
    &.bottom {
      top: 106%;
    }
  }
  .com-lang {
    &.normal {
      width: 64px;
      height: 44px;
      border-radius: 44px;
    }
  }
  .com-lang-global {
    width: 30px;
    height: 30px;
  }
  .com-lang-item {
    height: 72px;
    line-height: 72px;
    font-size: 32px;
  }
  .com-lang-text {
    font-size: 24px;
  }
  .com-lang-arrow {
    width: 24px;
    height: 24px;
  }
}
@media screen and (min-width: 1024px) {
  .com-lang-list {
    min-width: 120px;
  }
}
</style>
